<template>
    <li><slot></slot></li>
</template>

<script>
    /**
     * collapsible item
     * @module collapsible/collapsible-item
     * @author Jack Yang
     * @description a component for collapsible-item
     */
    module.exports = {};
</script>



/** WEBPACK FOOTER **
 ** collapsible-item.vue?1f4ede48
 **/